import React, { useCallback, useState } from 'react';
import { notNullOrEmpty } from '../../utils/common';

export type ImageLoaderProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
	dummy?: string;
	src: string | string[]
};

export const ImageLoader: React.FC<ImageLoaderProps> = (props) => {
	const { src, dummy, alt, onLoad, onLoadStart, ...other } = props;
	const images = typeof (src) === 'string' ? [src] : src;
	const [defaultImage, ...otherImages] = images;
	const [imageLoaded, setImageLoaded] = useState(false);

	const handleOnLoad = useCallback((event: React.SyntheticEvent<HTMLImageElement, Event>) => {
		setImageLoaded(true);
		onLoad?.(event);
	}, [onLoad, setImageLoaded]);

	const handleOnLoadStart = useCallback((event: React.SyntheticEvent<HTMLImageElement, Event>) => {
		setImageLoaded(false);
		onLoadStart?.(event);
	}, [onLoadStart, setImageLoaded]);

	return (
		<React.Fragment>
			{!imageLoaded && notNullOrEmpty(dummy) &&
				<img alt={alt} src={dummy} {...other} />}
			<picture style={{ display: !imageLoaded ? 'none' : 'flex', alignItems: 'center', justifyContent: 'center' }}>
				{otherImages.map(anotherFormatImage =>
					<source srcSet={anotherFormatImage} type={`image/${anotherFormatImage.split('.').pop()}`} />)}
				<img alt={alt} src={defaultImage} onLoad={handleOnLoad} onLoadStart={handleOnLoadStart} {...other} />
			</picture>
		</React.Fragment>
	);
};
